// extracted by mini-css-extract-plugin
export default {"filter":"productFilter_filter__xoEFd","category":"productFilter_category__TUaEV","brand":"productFilter_brand__oUUUk","active":"productFilter_active__SZLgI"};